import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import TopicBanner from './TopicBanner'
import TopicSummary from './TopicSummary'
import StyleTwoCurriculum from '../style-two/StyleTwoCurriculum'
import StyleTwoTabsClass from '../style-two/StyleTwoTabsClass'
import StyleTwoCertificate from '../style-two/StyleTwoCertificate'
import StyleTwoCommonQuestion from '../style-two/StyleTwoCommonQuestion'
import StyleTwoMobileClassrom from '../style-two/StyleTwoMobileClassrom'
import StyleTwoGuide from '../style-two/StyleTwoGuide'
import StyleTwoRaiders from '../style-two/StyleTwoRaiders'
import FixedNavigationModel from './FixedNavigationModel'
import { topicLicensedPharmacistImgs } from '../../images/topicImg'
import { SummaryLicensedPharmacistData, LicensedPharmacistCurriculumData, LicensedPharmacistClassData, LicensedPharmacistCertificateData, LicensedPharmacistCommonProblemData, LicensedPharmacistMobileClassromData, LicensedPharmacistPercentData, LicensedPharmacistRaidersData } from '../../utils/tools/publicParams'

function LicensedPharmacist() {
  const onMeiQiaCustomer = () => {
    window._MEIQIA('showPanel');
  }

  const ColorData = {
    color: 'rgba(28, 196, 115, 1)',
    opacityColor01: 'rgba(28, 196, 115, 0.1)',
    opacityColor006: 'rgba(28, 196, 115, 0.06)',
    backgroundImage: 'linear-gradient(90deg, #21d880 0%, #1cc473 100%),linear-gradient(#1cc473, #1cc473)'
  }
  const navigationModelData = [
    { id: 1, title: '课程体系', href: '#curriculum' },
    { id: 2, title: '单选班级', href: '#class' },
    { id: 3, title: '考情分析', href: '#certificate' },
    { id: 4, title: '备考攻略', href: '#raiders' },
    { id: 5, title: '报考指导', href: '#percent' },
    { id: 6, title: '常见问题', href: '#common' }
  ]

  return (
    <div className="topic-licensed-pharmacist">
      {/* 专题Banner */}
      <TopicBanner url={topicLicensedPharmacistImgs.Banner_bg} />
      {/* 汇总统计行 */}
      <TopicSummary SummaryData={SummaryLicensedPharmacistData} ContentColor={ColorData.color} />
      {/* 课程体系 - 版本二 */}
      <StyleTwoCurriculum itemsData={LicensedPharmacistCurriculumData} onMeiQiaCustomer={onMeiQiaCustomer} />
      {/* 单选班级 - 版本二 */}
      <StyleTwoTabsClass itemsData={LicensedPharmacistClassData} colorData={ColorData} onMeiQiaCustomer={onMeiQiaCustomer} />
      {/* 考情分析 - 版本二 */}
      <StyleTwoCertificate itemsData={LicensedPharmacistCertificateData} />
      {/* 备考攻略 - 版本二 */}
      <StyleTwoRaiders itemsData={LicensedPharmacistRaidersData} onMeiQiaCustomer={onMeiQiaCustomer} />
      {/* 报考指导 - 版本二 */}
      <StyleTwoGuide itemsData={LicensedPharmacistPercentData} />
      {/* 常见问题 版本二 */}
      <StyleTwoCommonQuestion itemsData={LicensedPharmacistCommonProblemData} colorData={ColorData} />
      {/* 移动课堂 版本二 */}
      <StyleTwoMobileClassrom itemsData={LicensedPharmacistMobileClassromData} />

      <FixedNavigationModel itemsData={navigationModelData} />
    </div>
  )
}
LicensedPharmacist.propTypes = {
  topic: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LicensedPharmacist);



// WEBPACK FOOTER //
// ./src/features/topic/LicensedPharmacist.js